import React, { useState, useEffect } from 'react';
import styled from 'styled-components';
import axios from 'axios';
import { useSelector, useDispatch } from 'react-redux';

const BannerContainer = styled.div`
  background-color: #fff3cd;
  color: #856404;
  padding: 12px 20px;
  border: 1px solid #ffeeba;
  border-radius: 4px;
  margin-bottom: 1rem;
  display: flex;
  justify-content: space-between;
  align-items: center;
  text-align: center;
`;

const MessageContainer = styled.div`
  flex-grow: 1;
  text-align: center;
`;

const CloseButton = styled.button`
  background: none;
  border: none;
  color: #856404;
  cursor: pointer;
  font-size: 1.5rem;
  padding: 0;
  line-height: 1;
  margin-left: 10px;
  &:hover {
    color: #533f03;
  }
`;

const Link = styled.a`
  color: #533f03;
  text-decoration: underline;
  display: inline-block;
  margin-top: 8px;
  &:hover {
    color: #533f03;
    text-decoration: none;
  }
`;

const UnsubscribeBanner = () => {
  const [visible, setVisible] = useState(true);
  const dispatch = useDispatch();
  const parent = useSelector((state) => state.parent);

  useEffect(() => {
    setVisible(
      parent.unsubscribedFromAll && !parent.unsubscribeBannerDismissed,
    );
  }, [parent]);

  const handleCloseClick = () => {
    dispatch({
      type: 'DISMISS_UNSUBSCRIBE_BANNER',
      payload: { unsubscribeBannerDismissed: true },
    });
  };

  if (!visible) {
    return null;
  }

  return (
    <BannerContainer>
      <MessageContainer>
        You're currently opted out of all email communications and may miss
        important announcements about upcoming events.
        <br />
        <Link href="/my-account">
          Please visit your account page to adjust your preferences
        </Link>
      </MessageContainer>
      <CloseButton onClick={handleCloseClick} aria-label="Close">
        ×
      </CloseButton>
    </BannerContainer>
  );
};

export default UnsubscribeBanner;
